import { type PaymentBreakdown, BreakdownTypes } from '../../types/PaymentBreakdown';
import { t } from '.';

const paymentBreakdownTypesMap: Record<keyof PaymentBreakdown, string> = {
  [BreakdownTypes.ItemsTotal]: 'itemsTotal',
  [BreakdownTypes.Tax]: 'tax',
  [BreakdownTypes.Shipping]: 'shipping',
  [BreakdownTypes.Discount]: 'discount',
};

export const getBreakdownLocaleKey = (type: keyof PaymentBreakdown): string =>
  `paymentSheet.paymentBreakdown.${paymentBreakdownTypesMap[type]}`;

export const getLocalizeBreakdownLabel = (type: keyof PaymentBreakdown): string => t(getBreakdownLocaleKey(type));
